import { getRegistrationInfo, saveRegistrationInfo } from "../api/registrationInfo";
import { getApplicationSettings, getInternationalCountries, getInternationalStates, getInternationalPreferredCountries } from "../api/applicationSettings";
import { quickCheckout } from "../api/checkout";
import { removeDefaultSessions } from "../api/registration";
import { getMembership } from "../api/membership";
import * as membershipActions from "../actions/membershipActions";
import * as registrationActions from "../actions/registrationActions";
import * as accountActions from "../actions/accountActions";
import { connect } from "react-redux";
import * as config from "../config";
import Page from "./Page";
import Box from "./Box";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import ProofOfStudiesUpload from "./ProofOfStudiesUpload";
import LoadingButton from "./LoadingButton";
import { toast } from "react-toastify";
import LoadingContent from "./LoadingContent";
import * as account from "../api/account";
import { fallConferenceSessionsUrl } from "../config";
import { nationalConferenceSessionsUrl } from "../config";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "postal-codes-js";
import libphonenumber from "google-libphonenumber";

// todo: move this to configuration
const strings = {
  conferenceTermsOfService: "https://www.aanp.org/aanp-conference-terms-of-service-and-release-of-liability",
  aanpTermsOfUse: "https://www.aanp.org/aanp-terms-of-use",
  aanpPrivacyPolicy: "https://www.aanp.org/aanp-privacy-policy",
};

const validationStrings = {
  error: "error",
  required: "This field is required.",
};

// this is used as a KVPair to reference a stateKey by . notation instead of strings
const input = {
  workingOrVolunteeringAsNP: "workingOrVolunteeringAsNP",
  howDidYouHear: "howDidYouHear",
  usNp: "usNp",
  primaryPracticeState: "primaryPracticeState",
};

const errorText = { color: "red" }

class DefaultConferenceQuestions extends PureComponent {
  
  static propTypes = {
    me: PropTypes.object.isRequired,
    storeRegistrationMembershipType: PropTypes.func.isRequired,
    storeRegistrationMethod: PropTypes.func.isRequired,
    registrationMembershipType: PropTypes.string,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {

    console.log("constructor");

    super(props);

    this.state = {      
      registrationInfo: {        
        memberType: "",
        registeringAs: "",
      },
      applicationSettings: [{}],
      internationalStates: [{}],
      isLoadingQuickCheckout: false,
      isLoadingCheckout: false,
      validation: {},
      loadingPrerequisites: true,
      loading: true,
      studentApprovalUploaded: false,
      usNp: "",
      primaryPracticeState: "",
  };
  }

  componentDidMount = () => {
    
    console.log("componentDidMount");

    this._getApplicationSettings();
    this._getRegistrationInfo();   
  };

  _getApplicationSettings = () => { 

    console.log("_getApplicationSettings");

    this.setState({ loadingPrerequisites: true });
    
    getApplicationSettings().then((response) => {        
      this.setState({ applicationSettings: JSON.parse(response), loadingPrerequisites: false });
    })    
  }

  _getInternationalStates = (countryName) =>
    {   
      console.log("_getInternationalStates");
  
      getInternationalStates(countryName).then((response) => {
        this.setState({ internationalStates: response });      
      })
    }

  _getRegistrationInfo = () => {

    console.log("_getRegistrationInfo");

    this.setState({ loading: true });

    getRegistrationInfo().then((response) => { 

      console.log("this.props.registrationMembershipType: " + this.props.registrationMembershipType);

      const registeringAs = this.props.registrationMembershipType;

      if (registeringAs === "Retired Member") {
        response.isRetired = true;
      } else if (registeringAs === "Post Master's Student") {
        response.isPostGrad = true;
      }

      if (registeringAs === "Career Starter Member") {
        response.isGraduated = true;
      } else if (localStorage.getItem(config.storageKeys.isNp) === "true") {
        response.isNp = true;
      }

      this.setState({ registrationInfo: response });

      
    //   const target = {
    //     name: "country",
    //     value: response.country,
    //   };

    //   const event = {        
    //     target,
    //   }
      this._getInternationalStates(response.country);

      //const usNp = (!response.primaryPracticeState || response.primaryPracticeState.length === 0) ? "" : "Yes";
      const usNp = (!response.workingOrVolunteeringAsNP || response.workingOrVolunteeringAsNP !== "Yes" || 
          !response.primaryPracticeState || response.primaryPracticeState.length === 0) ? "" : "Yes";

      //this._handleChange(event)

      this.setState((prevState) => ({
        ...prevState,
        registrationInfo: {
          ...prevState.registrationInfo,
          registeringAs: this._getMembershipType(),
          usNp: usNp,
        }, 
        loading: false,
      }));
    });
  };

  _handleChange = (e) => {   

    let { registrationInfo } = this.state;
    const validation = { ...this.state.validation };

    const target = e.target;
    const name = target.name;
    let value = target.value;    

    console.log("_handleChange target: " + target + " name: " + name + " value: " + value);

    delete validation[name];

    if (typeof e.target.checked !== "undefined" && e.target.type === "checkbox")
    {
      value = target.checked;
    }

    if (name === "isNp") 
    {
      if (value) 
      {
        registrationInfo.isGraduated = false;
      }
    } 
    else if (name === "isGraduated") 
    {
      if (value) 
      {
        registrationInfo.isNp = false;
      }
    } 
    else if (name === "workingOrVolunteeringAsNP") 
    {
      registrationInfo.isRetired = false;
      registrationInfo.isPostGrad = false;
      registrationInfo.isNp = false;
      registrationInfo.isGraduated = false;
      registrationInfo.primaryPracticeState = "";
      registrationInfo.usNp = "";
    }

    if (name === "usNp") {
      if (value === "No") {
        registrationInfo.primaryPracticeState = "";
      }
    }

    if (name === "isPostGrad") {
      registrationInfo.isRetired = false;
    } else if (name === "isRetired") {
      registrationInfo.isPostGrad = false;
    } 

    registrationInfo[name] = value;

    registrationInfo.registeringAs = this._getMembershipType();

    this.setState((prevState) => ({ ...prevState, validation, registrationInfo: { ...prevState.registrationInfo } }));
  };

  _getMembershipType = () => {
    console.log("_getMembershipType");
    let { registrationInfo } = this.state;

    let registeringAs = "";

    if (this.props.me.person.isMember) {
      registeringAs = this.props.me.person.memberType;
    }

    if (registrationInfo.isRetired) {
      registeringAs = "Retired Member";
    } else if (registrationInfo.isPostGrad) {
      registeringAs = "Post Master's Student";
    } else if (registrationInfo.isNp && !(registeringAs === "Student Member" || registeringAs === "International Student Member")) {
      registeringAs = "NP Member";     
    } else if (registrationInfo.isGraduated) {
      registeringAs = "Career Starter Member";
    } else if ((registeringAs === "Student Member" || registeringAs === "International Student Member") && !(registrationInfo.isNp || registrationInfo.isGraduated)) {      
      registeringAs = "NP Member";      
    } else if (registeringAs === "Post Master's Student Member" && !registrationInfo.isPostGrad) {
      registeringAs = "NP Member";
    }

    return registeringAs;
  };

  _saveRegistrationInfo = (e) => {
    console.log("_saveRegistrationInfo");
    if (e) {
      e.preventDefault();
    }

    if (this._validForm()) {

      console.log("this._validForm() === true");

      const nextPage = e.target.value;

      let { registrationInfo } = this.state;

      if (nextPage === "checkout") {
        this.setState({
          isLoadingQuickCheckout: true,
        });
      } else {
        this.setState({
          isLoadingCheckout: true,
        });
      }

      this.props.storeRegistrationMembershipType(
        registrationInfo.registeringAs
      );

      saveRegistrationInfo(registrationInfo).then((response) => {
        this.props.storeRegistrationMethod("");

        localStorage.setItem(config.storageKeys.isNp, registrationInfo.isNp);

        account.me().then((me) => {
          if (this.props.me.person.isMember) {
            const membershipType = this.props.me.availableMembershipTypes.find(
              (m) => m.useForJoinCampaign === true
            );
            if (
              registrationInfo.registeringAs === "Associate Member" &&
              me.person.memberType === "Associate Member" &&
              me.person.isMember
            ) {
              this.props.storeRegistrationMembershipType(
                registrationInfo.registeringAs
              );
            } else if (false && membershipType) {
              this.props.storeRegistrationMembershipType(
                membershipType.membershipTypeName
              );
              if (registrationInfo.registeringAs === "Associate Member") {
                registrationInfo.registeringAs =
                  membershipType.membershipTypeName;
              }
            } else {
              this.props.storeRegistrationMembershipType(
                registrationInfo.registeringAs
              );
            }
          }

          if (nextPage === "checkout") {
            this.props.storeRegistrationMethod("quick");
            if (!me.isRegistered) {
              quickCheckout().then((response) => {
                this.props.history.push("/checkout");
              });
            } else {
              this.props.history.push("/checkout");
            }
          } else {
            if (!me.isRegistered) {
              removeDefaultSessions().then((response) => {
                const showJoinRenew =
                  me.membershipStatus !== 1 &&
                  me.membershipStatus !== 2 &&
                  me.availableMembershipTypes.filter((m) => !m.disabledForUser)
                    .length > 0;

                if (showJoinRenew) {
                  if (!registrationInfo.registeringAs) {                    
                    registrationInfo.registeringAs = "NP Member";                    
                  }

                  getMembership(
                    registrationInfo.registeringAs,
                    localStorage.getItem(config.storageKeys.promoCode)
                  ).then((response) => {
                    if (
                      response.hasEventDiscount ||
                      response.savings <= response.savingsLimit
                    ) {
                      this.props.history.push("/" + nextPage);
                    } else {
                      this.props.history.push("/membership");
                    }
                  });
                } else {
                  this.props.history.push("/" + nextPage);
                }
              });
            } else {
              this.props.history.push("/" + nextPage);
            }
          }
        });
      });
    } else {
      console.log("this._validForm() === false");
      toast.error("Please review and complete the registration information.", {autoClose: 10000});
    }
  };

  _isValidEmail(email) {
    console.log("_isValidEmail");
    return /\S+@\S+\.\S+/.test(email);
  };
  
  _validForm = () => {

    console.log("_validForm");

    const validation = {};

    let { event } = this.props.me;

    let { registrationInfo } = this.state;
    console.log("valid reg info", registrationInfo);

    Object.keys(registrationInfo).forEach((stateKey) => {
      
      console.log("stateKey: " + stateKey);

      if (input[stateKey]) {

        if (stateKey === input.howDidYouHear && !registrationInfo.howDidYouHear) {
          console.log(stateKey + " failed validation");
          validation[input.howDidYouHear] = { state: validationStrings.error, helpBlock: validationStrings.required };
        }

        if (stateKey === input.workingOrVolunteeringAsNP && !registrationInfo.workingOrVolunteeringAsNP) {
          console.log(stateKey + " failed validation");
          validation[input.workingOrVolunteeringAsNP] = { state: validationStrings.error, helpBlock: validationStrings.required };
        }

        if (stateKey === input.usNp) {
          if(registrationInfo.workingOrVolunteeringAsNP === "Yes" && registrationInfo.usNp === "") {
            console.log(stateKey + " failed validation");
            validation[input.usNp] = { state: validationStrings.error, helpBlock: validationStrings.required };
          } 
        }

        if (stateKey === input.primaryPracticeState) {
          if(registrationInfo.workingOrVolunteeringAsNP === "Yes" && registrationInfo.usNp === "Yes" && !registrationInfo.primaryPracticeState) {
            console.log(stateKey + " failed validation");
            validation[input.primaryPracticeState] = { state: validationStrings.error, helpBlock: validationStrings.required };
          } 
        }
    }      
    });

    this.setState({ validation });

    return !Object.keys(validation).length;

  };

  _proofOfStudiesUploaded = () => {
    console.log("_proofOfStudiesUploaded");
    this.setState({ studentApprovalUploaded: true });
  };

  render() {

    if (this.state.loading || this.state.loadingPrerequisites) {
      return <LoadingContent />;
    }

    console.log("render");    

    let { registrationInfo, validation, studentApprovalUploaded } = this.state;
    let { event } = this.props.me;
    let currentMembershipType = this.props.me.person.memberType.toLowerCase();
    let showRegistrationType = this.props.me.person.isMember && event.studentQuestions;
    let enableProofUpload = registrationInfo.isNp || registrationInfo.isPostGrad;

    return (
      <Page title="Conference Registration">
        <form>
          <Box title="Register Now!">
            <div className="row">
              <div className="col-lg-6">
                <div
                  className={
                    "inner-content mb-2 " +
                    (validation[input.workingOrVolunteeringAsNP] ? validationStrings.error : "")
                  }
                >
                  <div>
                    <div className="question">
                      Are you currently working or volunteering as an NP?
                    </div>
                    <select
                      value={registrationInfo.workingOrVolunteeringAsNP ? registrationInfo.workingOrVolunteeringAsNP : ""}
                      name="workingOrVolunteeringAsNP"
                      onChange={this._handleChange}
                      className={
                        validation[input.workingOrVolunteeringAsNP] ? validationStrings.error : ""
                      }
                    >
                      <option value="">Please select one of the following</option>
                      <option>Yes</option>
                      <option>No, I am a retired NP</option>
                      <option>No, I am a NP Student</option>
                      <option>No, I am an other APRN (CNS, CNM, CRNA)</option>
                      <option>No, other nurse</option>
                      <option>No, I am an NP but not currently working</option>
                      <option>No, I am not an NP or a nurse</option>
                    </select>
                  </div>
                  {registrationInfo.workingOrVolunteeringAsNP === "No, I am not an NP or a nurse" && (
                    <div>
                      <div className="divider" />
                      <div>
                        <div className="question">
                          Working as (please select one of the following):
                        </div>
                        <select
                          value={registrationInfo.nonNPJobProfession ? registrationInfo.nonNPJobProfession : ""}
                          name="nonNPJobProfession"
                          onChange={this._handleChange}
                        >
                          <option value="">
                            Please select one of the following
                          </option>
                          <option value="Physician">Physician</option>
                          <option value="Podiatrist">Podiatrist</option>
                          <option value="Optometrist">Optometrist</option>
                          <option value="Pharmacist">Pharmacist</option>
                          <option value="Chiropractor">Chiropractor</option>
                          <option value="Dentist">Dentist</option>
                          <option value="Physician Assistant">
                            Physician Assistant
                          </option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                  )}

                  {registrationInfo.workingOrVolunteeringAsNP === "Yes" && (
                    <div>
                      <div className="divider" />
                      <div>
                        <div className="question">
                          Are you currently working as an NP in the United States?
                        </div>
                        <select
                              value={registrationInfo.usNp ? registrationInfo.usNp : ""}                                                    
                              name="usNp"
                              onChange={this._handleChange}
                              className={validation[input.usNp] ? validationStrings.error : ""}
                            >
                              <option value="">Please select yes or no</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                          </select>
                      </div>
                      {registrationInfo.usNp === "Yes" && (
                      <div>
                        <div className="divider" />
                        <div>           
                          <div className="question">
                            What is your primary practice state?
                          </div>
                            <select
                              value={registrationInfo.primaryPracticeState ? registrationInfo.primaryPracticeState : ""}                                                    
                              name="primaryPracticeState"
                              onChange={this._handleChange}
                              className={validation[input.primaryPracticeState] ? validationStrings.error : ""}
                            >                
                              <option value="">Select a primary practice state</option>
                              {this.state.internationalStates.map((state, key) => (
                                <option 
                                  key={key} 
                                  value={state.stateAbbreviation}>{state.stateName}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        )}
                      </div>
                    )}

                </div>
                <div className="divider d-lg-none" />

                <div className="divider d-lg-none" />                
              </div>              
              <div className="col-lg-6">
                <div
                    className={"inner-content mb-2 " + (validation[input.howDidYouHear] ? validationStrings.error : "")}
                    >
                    <div className="question">
                        How Did You Hear About the Conference?
                    </div>
                    <select
                        value={ registrationInfo.howDidYouHear ? registrationInfo.howDidYouHear : "" }
                        name="howDidYouHear"
                        onChange={this._handleChange}
                        className={ validation[input.howDidYouHear] ? validationStrings.error : "" }
                    >                    
                        <option value="">Please select one of the following</option>
                        <option>AANP Website</option>
                        <option>Facebook, Twitter or other website</option>
                        <option>Email</option>
                        <option>Postcard</option>
                        <option>Advertisement (JNP, JAANP or other)</option>
                        <option>Friend/Colleague</option>
                    </select>
                </div>
                <div className="divider d-lg-none" />  
            </div>
          </div>
          
            {showRegistrationType && (              
              <div className="row">
                <div className="col-lg-6">
                  <div className="divider d-lg-none" />
                  <div className="registration-type">
                    <div className="section-header mb-3 d-none">
                      Registration Type: {registrationInfo.registeringAs}
                    </div>
                    {currentMembershipType.includes("np") && (
                      <React.Fragment>
                        <div className="checkbox-container">
                          <label
                            className="question"
                            htmlFor="graduate-studies"
                          >
                            I am enrolled in post-graduate studies
                          </label>
                          <input
                            type="checkbox"
                            name="isPostGrad"
                            id="graduate-studies"
                            checked={!!registrationInfo.isPostGrad}
                            onChange={this._handleChange}
                          />
                        </div>
                        <div className="checkbox-container">
                          <label className="question" htmlFor="recently">
                            I have recently retired
                          </label>
                          <input
                            type="checkbox"
                            name="isRetired"
                            id="recently"
                            checked={!!registrationInfo.isRetired}
                            onChange={this._handleChange}
                          />
                        </div>
                      </React.Fragment>
                    )}
                    {currentMembershipType.includes("post") && (
                      <div className="checkbox-container">
                        <label className="question" htmlFor="graduate-studies">
                          I am enrolled in post-graduate studies
                        </label>
                        <input
                          type="checkbox"
                          name="isPostGrad"
                          id="graduate-studies"
                          checked={!!registrationInfo.isPostGrad}
                          onChange={this._handleChange}
                        />
                      </div>
                    )}
                    {currentMembershipType.includes("student") &&
                      !currentMembershipType.includes("post") && (
                        <React.Fragment>
                          <div className="checkbox-container">
                            <label className="question" htmlFor="enrolled">
                              I am enrolled in an NP program at this time
                            </label>
                            <input
                              type="checkbox"
                              id="enrolled"
                              name="isNp"
                              checked={registrationInfo.isNp}
                              onChange={this._handleChange}
                            />
                          </div>
                        </React.Fragment>
                      )}
                    {currentMembershipType.includes("student") &&
                      !currentMembershipType.includes("post") && (
                        <div className="checkbox-container">
                          <label className="question" htmlFor="graduated">
                            I have graduated in the last 12 months
                          </label>
                          <input
                            type="checkbox"
                            name="isGraduated"
                            id="graduated"
                            checked={!!registrationInfo.isGraduated}
                            onChange={this._handleChange}
                          />
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="mt-1 pb-4 d-none d-lg-block" />
                  {!studentApprovalUploaded && enableProofUpload && (
                    <ProofOfStudiesUpload
                      onUploaded={this._proofOfStudiesUploaded}
                      enabled={enableProofUpload}
                    />
                  )}
                </div>
              </div>
            )}
          </Box>

          {event.quickCheckout && event.sessionSelection && (
            <div>

              {/* 
              - What's Next = True
              - Session frame = True
              - Quick frame = True
              - TOS Under both frames = True
              - Button under TOS = False
              */}

              <Box title="Next Steps">
                <div className="row checkout" >

                  {/* TOS */}
                  <div className="row" style={{marginLeft: "1px", marginRight: "1px", marginBottom: "25px"}}>
                    <div className="col-lg-12 col-centered">
                      <div className="tos-box p-4">
                        By continuing the registration process, I agree to abide by the AANP Conference{" "}
                        <a style={{ fontWeight: "bold" }}
                          href={strings.conferenceTermsOfService}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Service and Release of Liability.
                        </a>{" "}
                        I additionally agree to abide by AANP’s{" "}
                          <a style={{ fontWeight: "bold" }}
                          href={strings.aanpTermsOfUse}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Use
                        </a>{" "}
                        and{" "}
                        <a style={{ fontWeight: "bold" }}
                          href={strings.aanpPrivacyPolicy}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Privacy Policy
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* Quick Checkout Frame */}                
                  <div className="col-lg">
                    <div className="inner-content mb-2">
                      <div className="txt-sm-bold">Quick Checkout</div>
                      <p>
                        Short on time? No problem! Pay now and come back to
                        select your sessions anytime with the Quick Checkout
                        option.
                      </p>                      
                        <LoadingButton
                          text="Agree and Checkout"
                          loadingText="Saving..."
                          isLoading={this.state.isLoadingQuickCheckout}
                          onClick={this._saveRegistrationInfo}
                          value="checkout"
                        />                
                    </div>
                  </div>                 

                  {/* Session Frame */}
                  <div className="col-lg">
                      <div className="inner-content mb-2">
                        <div className="txt-sm-bold">Session Selection</div>
                        <p>
                          Have a few minutes? Select your sessions now and pay
                          afterward.
                        </p>                        
                          <LoadingButton
                            text="Agree and Select Sessions"
                            loadingText="Saving..."
                            isLoading={this.state.isLoadingCheckout}
                            onClick={this._saveRegistrationInfo}
                            value="sessions"
                          />                       
                      </div>
                    </div>
                </div>
              </Box>
            </div>
          )}

          {event.quickCheckout && !event.sessionSelection && (
            <div>

              {/* 
              - What's Next = False
              - Session frame = False
              - Quick frame = False
              - TOS = True
              - Button under TOS = True
              */}

              <div className="row checkout">  

                  {/* TOS */}
                  <div className="row mt-3">
                    <div className="col-lg-11 col-centered">
                      <div className="tos-box p-4">
                        By continuing the registration process, I agree to abide by the AANP Conference{" "}
                        <a style={{ fontWeight: "bold" }}
                          href={strings.conferenceTermsOfService}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Service and Release of Liability.
                        </a>{" "}
                        I additionally agree to abide by AANP’s{" "}
                          <a style={{ fontWeight: "bold" }}
                          href={strings.aanpTermsOfUse}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Use
                        </a>{" "}
                        and{" "}
                        <a style={{ fontWeight: "bold" }}
                          href={strings.aanpPrivacyPolicy}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Privacy Policy
                        </a>
                      </div>

                      {/* Button */}
                      <div className="row mt-3">
                      <div className="col-10 col-lg-5 col-centered">
                          <LoadingButton
                              text="Agree and Checkout"
                              loadingText="Saving..."
                              isLoading={this.state.isLoadingQuickCheckout}
                              onClick={this._saveRegistrationInfo}
                              value="checkout"
                            />
                          </div>
                      </div>

                    </div>

                  </div>

              </div>

            </div>
          )}

          {!event.quickCheckout && event.sessionSelection && (
            <div>

              {/* 
              - What's Next = False
              - Session frame = False
              - Quick frame = False
              - TOS  = True
              - Button under TOS = True
              */}

              <div className="row checkout">  

                  {/* TOS */}
                  <div className="row mt-3">
                    <div className="col-lg-11 col-centered">
                      <div className="tos-box p-4">
                        By continuing the registration process, I agree to abide by the AANP Conference{" "}
                        <a style={{ fontWeight: "bold" }}
                          href={strings.conferenceTermsOfService}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Service and Release of Liability.
                        </a>{" "}
                        I additionally agree to abide by AANP’s{" "}
                          <a style={{ fontWeight: "bold" }}
                          href={strings.aanpTermsOfUse}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Use
                        </a>{" "}
                        and{" "}
                        <a style={{ fontWeight: "bold" }}
                          href={strings.aanpPrivacyPolicy}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Privacy Policy
                        </a>
                      </div>

                      {/* Button */}
                      <div className="row mt-3">
                        <div className="col-10 col-lg-5 col-centered">
                          <LoadingButton
                              text="Agree and Select Sessions"
                              loadingText="Saving..."
                              isLoading={this.state.isLoadingCheckout}
                              onClick={this._saveRegistrationInfo}
                              value="sessions"
                            />
                          </div>
                      </div>

                    </div>

                  </div>

              </div>

            </div>
          )}

          {!event.quickCheckout && !event.sessionSelection && (
            <div>

              {/* 
              - What's Next = False
              - Session frame = False
              - Quick frame = False
              - TOS  = False
              - Button under TOS = False
              */}

              {/* Intentionally Left Blank */}

            </div>
          )}

        </form>
        {event.sessionSelection && (
            <footer className="mb-1 mt-3 ml-3 mr-3">
            <div className="txt-sm-bold">
              Are You Interested in Learning More Before Registering?
            </div>
            <div className="footer-text">
              View the{" "}
              {event.conferenceType === "Fall" && (
              <a href={fallConferenceSessionsUrl} target="_blank" rel="noopener noreferrer">Session Detail Listing</a>
              )}
              {event.conferenceType === "National" && (
              <a href={nationalConferenceSessionsUrl} target="_blank" rel="noopener noreferrer">Session Detail Listing</a>
              )}        
              {/* Fall through */}
              {event.conferenceType !== "Fall" && event.conferenceType !== "National" && (
              <a href="https://sessions.aanp.org" target="_blank" rel="noopener noreferrer">Session Detail Listing</a>
              )}
              {" "}for more information on what will be offered during this conference.
            </div>
          </footer>
        )}
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    me: state.account.me,
    registrationMembershipType: state.membership.registrationMembershipType,
  };
};

const mapDispatchToProps = {
  ...membershipActions,
  ...registrationActions,
  ...accountActions,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DefaultConferenceQuestions)
);